import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { ContainerModel } from '@app/models/server/layout.model';
import { from } from 'rxjs';
import { ComponentRef, OverlayEventDetail } from '@ionic/core';
import { ModalController } from '@ionic/angular/standalone';
import {TapEffect} from '@app/components/directives/tap-effect.ts/tap-effect';

@Component({
  selector: 'app-properties-not-found',
  templateUrl: './properties-not-found.component.html',
  styleUrls: ['./properties-not-found.component.scss'],
  standalone: true,
  imports: [TapEffect],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertiesNotFoundComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
  } = {
    container: {},
  };

  modalController: ModalController;

  constructor() {
    this.modalController = inject(ModalController);
  }

  ngOnInit() {}

  enquriyNow() {
    this.openContactUsForm();
  }

  openContactUsForm() {
    from(
      import(
        '@app/new-ui-lib/b2b-cards/components/b2b-contact-us-form-card/b2b-contact-us-form-card.component'
      ).then((c) => c.B2bContactUsFormCardComponent),
    ).subscribe({
      next: async (componentRef: ComponentRef) => {
        const modal: HTMLIonModalElement = await this.modalController.create({
          component: componentRef,
          initialBreakpoint: 1,
          breakpoints: [0, 1],
          cssClass: 'enquiry-modal',
        });

        modal.onDidDismiss().then((result: OverlayEventDetail<any>) => {});

        return await modal.present();
      },
    });
  }
}
